"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Header = _interopRequireDefault(require("./Header"));

var _Content = _interopRequireDefault(require("./Content"));

var _utils = require("../../../utils");

var _uid = _interopRequireDefault(require("../../../utils/uid"));

require("./AccordionPanel.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function AccordionPanel(props) {
  var id = props.id,
      count = props.count,
      header = props.header,
      panelKey = props.panelKey,
      isActive = props.isActive,
      disabled = props.disabled,
      children = props.children,
      accordion = props.accordion,
      classNameProp = props.className,
      headerClass = props.headerClass,
      onItemClick = props.onItemClick;

  var onClick = function onClick() {
    onItemClick(panelKey);
  };

  var uId = (0, _react.useMemo)(function () {
    return id || (0, _uid.default)('content');
  }, [id]);
  var role = (0, _react.useMemo)(function () {
    return accordion ? 'tab' : 'button';
  }, [accordion]);
  var tabIndex = (0, _react.useMemo)(function () {
    return disabled ? -1 : 0;
  }, [disabled]);
  var className = (0, _utils.getClassNames)('AccordionPanel', classNameProp, {
    AccordionPanel__active: isActive
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    className: className
  }, /*#__PURE__*/_react.default.createElement(_Header.default, {
    uId: uId,
    role: role,
    count: count,
    tabIndex: tabIndex,
    isActive: isActive,
    headerClass: headerClass,
    onClick: onClick
  }, header), /*#__PURE__*/_react.default.createElement(_Content.default, {
    uId: uId,
    isActive: isActive
  }, children));
}

AccordionPanel.propTypes = {
  id: _propTypes.default.string,
  count: _propTypes.default.number,
  header: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node]),
  panelKey: _propTypes.default.string,
  isActive: _propTypes.default.number,
  disabled: _propTypes.default.number,
  children: _propTypes.default.node,
  accordion: _propTypes.default.bool,
  className: _propTypes.default.string,
  headerClass: _propTypes.default.number,
  onItemClick: _propTypes.default.func
};
AccordionPanel.defaultProps = {
  id: null,
  count: null,
  header: null,
  panelKey: null,
  isActive: false,
  disabled: false,
  children: null,
  accordion: false,
  className: null,
  headerClass: null,
  onItemClick: function onItemClick() {}
};
var _default = AccordionPanel;
exports.default = _default;